/* Skeleton.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _7 = "@media (min-width:48rem){._15fll6l0{margin-top:var(--ds-space-300)}}";
const _6 = "._19pkoxav{margin-top:var(--ds-space-150)}";
const _5 = "._zulpxjmg{gap:var(--ds-space-200)}";
const _4 = "._1bsb1osq{width:100%}";
import { media } from '@atlaskit/primitives';
import { AppTileGridSkeleton, AppTileSize } from '@atlassian/mpac-app-tile';
import { breakpointValues, Stripe, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import React from 'react';
import { TEST_IDS } from '../../testids';
import { SectionHeader, TrustSignalsWrapper } from './TrustSignalsSection';
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
const HeaderContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _2lx21bp4 _4cvr1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  HeaderContainer.displayName = 'HeaderContainer';
}
const TextContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_4, _, _2, _3, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o _zulpxjmg _19pkoxav _15fll6l0", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  TextContainer.displayName = 'TextContainer';
}
const HeaderSkeleton = () => {
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  const isTablet = breakpoint < breakpointValues.md && breakpoint >= breakpointValues.sm;
  return /*#__PURE__*/React.createElement(HeaderContainer, null, /*#__PURE__*/React.createElement(Stripe, {
    width: "50%"
  }), /*#__PURE__*/React.createElement(TextContainer, null, isTablet ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stripe, {
    height: "14px",
    width: "75%"
  }), /*#__PURE__*/React.createElement(Stripe, {
    height: "14px",
    width: "70%"
  })) : isMobile ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stripe, {
    height: "12px"
  }), /*#__PURE__*/React.createElement(Stripe, {
    height: "12px"
  }), /*#__PURE__*/React.createElement(Stripe, {
    height: "12px"
  })) : /*#__PURE__*/React.createElement(Stripe, {
    width: "75%",
    height: "14px"
  })));
};
export const TrustSignalsSectionSkeleton = () => {
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": TEST_IDS.TRUST_SIGNAL_SKELETON
  }, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(HeaderSkeleton, null)), /*#__PURE__*/React.createElement(TrustSignalsWrapper, null, /*#__PURE__*/React.createElement(AppTileGridSkeleton, {
    tileCount: 3,
    size: AppTileSize.SMALL
  })));
};